import { t } from "i18next";
import useWhiteLabel from "whitelabel/useWhiteLabel";
/*eslint-disable*/
export default function Footer() {
  const { links } = useWhiteLabel();
  return (
    <div className="z-[5] mb-6 grid h-full w-full grid-cols-1 lg:grid-cols-2">
      <div className="col-span-1">
        <p className="flex items-center justify-center text-txt-sm text-white md:px-40 lg:justify-start 3xl:px-64">
          ©{new Date().getFullYear()} {t("footer.all.rights")}
        </p>
      </div>
      <div className="col-span-1">
        <ul className="flex items-center justify-center gap-4">
          <li>
            <a
              target="blank"
              href={links.support}
              className="text-txt-sm text-white"
            >
              {t("footer.support")}
            </a>
          </li>
          <li>
            <a
              target="blank"
              href={links.privacyPolicy}
              className="text-txt-sm text-white"
            >
              {t("footer.privacy.policy")}
            </a>
          </li>
          <li>
            <a
              target="blank"
              href={links.terms}
              className="text-txt-sm text-white"
            >
              {t("footer.terms.use")}
            </a>
          </li>
          <li>
            <a
              target="blank"
              href={links.contact}
              className="text-txt-sm text-white"
            >
              {t("footer.contact.us")}
            </a>
          </li>
        </ul>
      </div>
    </div>
  );
}
